import { render } from "./MyExperience.vue?vue&type=template&id=5a54771a"
import script from "./MyExperience.vue?vue&type=script&lang=js"
export * from "./MyExperience.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3192575638/src/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__